/**
 * Action types for classifications reducer
 */
export default {
    FETCH_INIT: "CLASSIFICATIONS/FETCH_INIT",
    FETCH_SUCCESS: "CLASSIFICATIONS/FETCH_SUCCESS"
};
